import OrderPaymentDisplayType
  from '../components/orders/OrderPaymentDisplayType';
import OrderStatusDisplayType
  from '../components/orders/OrderStatusDisplayType';
import convertNumberToFinancialString from '../utility/convertNumberToFinancialString';

class CrmOrder {
  constructor(
    id,
    createdAt,
    orderNumber,
    grandTotal,
    shippingTimestamp,
    shippingStatus,
    poNumber,
    paymentStatus,
    shipmentList,
    currency,
    crmOrgId,
  ) {
    this.id = id;
    this.createdAt = createdAt;
    this.orderNumber = orderNumber;
    this.grandTotal = grandTotal;
    this.shippingTimestamp = shippingTimestamp;
    this.shippingStatus = shippingStatus;
    this.poNumber = poNumber;
    this.paymentStatus = paymentStatus;
    this.shipmentList = shipmentList;
    this.currency = currency;
    this.crmOrgId = crmOrgId;
  }

  get paymentType() {
    switch (this.paymentStatus) {
      case 'Cancelled': {
        return OrderPaymentDisplayType.CANCELLED;
      }
      case 'Refunded': {
        return OrderPaymentDisplayType.REFUNDED;
      }
      case 'Closed': {
        return OrderPaymentDisplayType.CLOSED;
      }
      case 'Pending':
      case 'Paid': {
        return OrderPaymentDisplayType.PAID;
      }
      case 'New':
      case 'Dead':
      case 'Part Paid':
      case 'Hold':
      case 'Invoiced':
      case 'Open': {
        return OrderPaymentDisplayType.OPEN;
      }
      default: return OrderPaymentDisplayType.OPEN;
    }
  }

  get statusType() {
    const deliveredCount = this.shipmentList
      .reduce((acc, curr) => (curr.isDelivered === true ? acc + 1 : acc), 0);
    if (this.shippingStatus === 'Cancelled') {
      return OrderStatusDisplayType.CANCELLED;
    }
    if (this.shippingStatus === 'Open') {
      return OrderStatusDisplayType.RECEIVED;
    }
    if (this.shippingStatus === 'Hold') {
      return OrderStatusDisplayType.HOLD;
    }
    if (this.shipmentList.length > 1 && this.shipmentList.length > deliveredCount > 0) {
      return OrderStatusDisplayType.PARTIAL;
    }
    if (deliveredCount === this.shipmentList.length) {
      return OrderStatusDisplayType.DELIVERED;
    }
    if (this.shippingTimestamp && this.shippingStatus === 'Shipped') {
      return OrderStatusDisplayType.SHIPPED;
    }
    return OrderStatusDisplayType.RECEIVED;
  }

  get dueDate() {
    return this.shippingTimestamp != null
      ? this.shippingTimestamp + 2592000
      : null;
  }

  get poDisplayNumber() {
    return this.poNumber != null
      ? this.poNumber
      : '-';
  }

  get grandTotalDisplay() {
    if (!this.grandTotal || this.grandTotal === '0') {
      return convertNumberToFinancialString(0, this.currency);
    }
    return convertNumberToFinancialString(this.grandTotal, this.currency);
  }
}
export default CrmOrder;
